<template>
  <!-- eslint-disable max-len -->
  <info>
    <h1>{{ $t("ABOUT_APPDB") }}</h1>
    <div v-html="$t('ABOUT_APPDB_DESC')"></div>

    <template slot="sidebar">
      <h2>{{ $t("DONATIONS") }}</h2>
      <p
        v-html="
          $t('WE_ARE_ALWAYS_OPEN_DONATIONS', {
            bitcoinAddress: '1AZsEJvZYtH9An4iJi1QJa2tiNMKYgNTvN',
          }) +
          `. ETH: <strong>0xc21350edf0C7a0998fDd264eBaDd5772f2e317B5</strong>`
        "
      ></p>
      <template v-if="BRAND_KEY === 'appdb'">
        <h2>{{ $t("STAY TUNED") }}</h2>
        <html-with-links
          tag="p"
          :html="
            $t('APPDB_SOCIAL', {
              twitterLink: 'https://twitter.com/appdb_official',
              storyLink: '/info/empire-strikes-back',
            })
          "
        ></html-with-links>
      </template>
    </template>
  </info>
</template>

<script>
import Info from '@/components/Info';
import HtmlWithLinks from '@/components/HtmlWithLinks';

export default {
  components: { Info, HtmlWithLinks },
  computed: {
    title() {
      return `About ${this.BRAND_CONFIG.name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
p::v-deep {
  br {
    display: none;
  }

  br + p {
    margin-top: 7px;
  }
}
</style>
